import { showModal } from '@/redux/reducers/modalsSlice';
import { MODAL_LIVE_QUERY } from '@/Utils/constants';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import Icon from '../UI/Icon/Icon';

const LiveQueryTag = ({ external }) => {
  const dispatch = useDispatch();
  const openViewOnlyModal = () => dispatch(showModal({ name: MODAL_LIVE_QUERY }));

  return (
    <div
      role='button'
      tabIndex='0'
      onClick={openViewOnlyModal}
      onKeyDown={openViewOnlyModal}
      className={clsx(
        'hover:bg-pear-200 absolute cursor-pointer top-[38px] right-0 tracking-tight rounded-full bg-pear-100 border-pear-700 border flex text-sm px-2 py-1 h-6 items-center gap-1 text-pear-800 font-medium',
        !external && 'hidden'
      )}
    >
      <Icon name='database' color='#889121' size={16} weight='duotone' className='mb-[1px]' />
      Live Query
    </div>
  );
};

export default LiveQueryTag;
